import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { SKIP_GLOBAL_LOADING } from './loading-context';

/**
 * Interceptor HTTP para mostrar/ocultar el overlay global de carga.
 * Se salta las peticiones que llevan SKIP_GLOBAL_LOADING en el contexto
 * (típicamente las llamadas paginadas de las tablas, que tienen feedback local).
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_GLOBAL_LOADING)) {
    return next(req);
  }

  const loadingService = inject(LoadingService);
  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      loadingService.hide();
    }),
  );
};
